import React, { useEffect, useState } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import Header from "../home/header";
import Loading from "../home/Loading";
import Login from "../home/login_form";
import { useLocation, useNavigate } from "react-router";
import UTILS from "../../utils/commons";
import { ApiClient } from "../../utils/api-client";
import { AxiosError } from "axios";

const TransactionForm = props => {
  var navigate = useNavigate();
  const loginState = JSON.parse( window.sessionStorage.getItem( "loginState" ) );
  const apiClient = new ApiClient( loginState ? loginState.accessToken : null );

  // ...existing code...
  const [ customers, setCustomers ] = useState( [] );
  const [ issues, setIssues ] = useState( [] );
  const [ products, setProducts ] = useState( [] );
  const [ isLoading, setIsLoading ] = useState( false );
  const [ feedback, setFeedback ] = useState( "" );
  const [ selectedFile, setSelectedFile ] = useState( null );

  const initialValues = {
    type: 0,
    customer: 0,
    invoiceNumber: '',
    products: [
      { productId: 0, quantity: 1, price: 0, amount: 0 }
    ],
    file: null,
    totalAmount: 0
  };

  const validationSchema = Yup.object( {
    type: Yup.number().required(),
    customer: Yup.string().required( "Required" ),
    products: Yup.array().of(
      Yup.object().shape( {
        productId: Yup.string().required( "Required" ),
        quantity: Yup.number().min( 1, "Quantity must be at least 1" ).required( "Required" ),
        price: Yup.number().min( 1, "Price must be at least 1" ).required( "Required" ),
        amount: Yup.number().min( 1, "Amount must be at least 1" ).required( "Required" ),
      } )
    ).min( 1, "At least one product is required" )
  } );

  const handleSubmit = async ( values, { setSubmitting, setFieldError } ) => {
    setIsLoading( true );
    let transaction = {
      type: parseInt( values.type ),
      customerId: values.customer,
      invoiceNumber: values.invoiceNumber,
      transactionProducts: values.products.map( p => ( {
        productId: p.productId,
        quantity: p.quantity,
        price: p.price,
        amount: p.amount
      } ) ),
      profileId: loginState.profile.id,
      totalAmount: values.products.reduce( ( sum, p ) => sum + ( Number( p.amount ) || 0 ), 0 )
    };
    if ( selectedFile ) {
      transaction.file = selectedFile;
    }
    if ( transaction.customerId == 0 || transaction.transactionProducts.length === 0 ) {
      setFeedback( "Please fill in the missing information" );
      setIsLoading( false );
      setSubmitting( false );
    } else {
      await saveTransaction( transaction );
      setIsLoading( false );
      setSubmitting( false );
    }
  };
  const handleFileChange = ( event ) => {
    const file = event.currentTarget.files[ 0 ];
    if ( file ) {
      let reader = new FileReader();
      reader.onload = ( e ) => {
        // e.target.result is a base64 string
        setSelectedFile( e.target.result );
      };
      reader.readAsDataURL( file );
    }
  }
  //save transaction
  const saveTransaction = async ( transaction ) => {

    try {
      const result = await apiClient.post( "transactions", transaction )
      navigate( "/transactions", { replace: false, state: result.data } );
    } catch ( error ) {
      console.log( "🚀 ~ saveTransaction ~ error:", error )
      setFeedback( error instanceof AxiosError && error.response.data?.error?.message ? error.response.data.error.message : "An error occurred while saving the transaction. Please try again." );
    }

  }


  // All form state and logic is now handled by Formik

  const loadData = async () => {
    setIsLoading( true );
    const [ customersPromise, issuesPromise ] = await Promise.all( [
      apiClient.get( `customers/profile/${loginState.profile.id}` ),
      apiClient.get( `issues/profile/${loginState.profile.id}` ),
      //   apiClient.get(`products/profile/${loginState.profile.id}`)
    ] );

    setIsLoading( false );
    if ( customersPromise.status === 200 ) {
      const customersData = await customersPromise.data;
      setCustomers( customersData );
    }
    if ( issuesPromise.status === 200 ) {
      const issuesData = await issuesPromise.data;
      setIssues( issuesData );
      setProducts( issuesData.map( i => {
        return { ...i.product, price: Number( i.sellingPrice ), invoiceNumber: i.invoiceNumber, quantity: i.quantity, availableQuantity: ( i.quantity - i.sold ) };
      } ) );
    }


  }
  // Amount calculation is handled inside Formik render props

  useEffect( () => {
    loadData();
  }, [] )
  if ( loginState ) {
    return (
      <>
        <Header auth={loginState} />
        <section className="flex justify-start items-start">
          <div className="container mx-auto md:mt-8">
            {feedback.length > 0 ? <div className="w-10/12 md:w-8/12 mx-auto mb-4 rounded-md border border-red-200 bg-red-50 px-3 py-2 text-red-700 text-sm" id="form-feedback">{feedback}</div> : null}
            <div className="md:w-10/12 md:mx-auto rounded-xl border border-gray-200 bg-white shadow-md py-10 px-3 md:px-6">
              <div className="text-center mx-auto w-full">
                <p className="text-sm uppercase tracking-wide text-gray-500 text-center">Transaction Setup</p>
                <p className="text-center text-2xl font-semibold text-gray-800 my-3">Make a Sale</p>
                <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={handleSubmit}
                >
                  {( { values, setFieldValue, errors, touched, isSubmitting } ) => {
                    // Handlers for dynamic product rows
                    const handleProductChange = ( idx, e ) => {
                      const productId = e.target.value;
                      const selected = products.find( p => String( p.id ) === String( productId ) );
                      const updated = values.products.map( ( row, i ) =>
                        i === idx
                          ? {
                            ...row,
                            productId,
                            price: selected ? selected.price : 0,
                            quantity: 1,
                            amount: selected ? selected.price : 0
                          }
                          : row
                      );
                      setFieldValue( 'products', updated );
                    };
                    const handleQuantityChange = ( idx, e ) => {
                      const val = e.target.value;
                      let quantity = val === '' ? '' : Number( val );
                      const selected = products.find( p => String( p.id ) === String( values.products[ idx ].productId ) );
                      if ( selected && quantity !== '' && quantity > Number( selected.availableQuantity ) ) {
                        quantity = Number( selected.availableQuantity );
                      }
                      const updated = values.products.map( ( row, i ) =>
                        i === idx
                          ? { ...row, quantity, amount: row.price * ( quantity === '' ? 0 : quantity ) }
                          : row
                      );
                      setFieldValue( 'products', updated );
                    };
                    const handlePriceChange = ( idx, e ) => {
                      const val = e.target.value;
                      const price = val === '' ? '' : Number( val );
                      const updated = values.products.map( ( row, i ) =>
                        i === idx
                          ? { ...row, price, amount: ( price === '' ? 0 : price ) * ( row.quantity === '' ? 0 : row.quantity ) }
                          : row
                      );
                      setFieldValue( 'products', updated );
                    };
                    const addProductRow = () => {
                      setFieldValue( 'products', [
                        ...values.products,
                        { productId: 0, quantity: 1, price: 0, amount: 0 }
                      ] );
                    };
                    const removeProductRow = ( idx ) => {
                      setFieldValue( 'products', values.products.filter( ( _, i ) => i !== idx ) );
                    };
                    // Calculate total amount
                    const totalAmount = values.products.reduce( ( sum, row ) => sum + ( Number( row.amount ) || 0 ), 0 );
                    return (
                      <Form id="sale_form" className="text-start w-10/12 md:w-9/12 mx-auto">
                        <div className="row">
                          <div className="form-group my-2 w-full text-right">
                            <label className="font-bold">Total Amount: </label>
                            <span className="ml-2">{UTILS.thousandSeparator( totalAmount )}</span>
                          </div>
                          <div className="form-group my-2 w-10/12 md:w-6/12">
                            <label htmlFor="type">Transaction Type</label>
                            <Field as="select" className="form-control" id="type" name="type">
                              <option value="0">Cash Sale</option>
                              <option value="1">Credit Sale</option>
                            </Field>
                          </div>
                          <div className="form-group my-2 w-10/12 md:w-6/12">
                            <label htmlFor="customer">Customer</label>
                            <Field as="select" className="form-control" id="customer" name="customer">
                              <option value="0">--select customer--</option>
                              {customers.map( c => (
                                <option key={c.id} value={c.id}>{c.name}</option>
                              ) )}
                            </Field>
                            {errors.customer && touched.customer ? <div className="text-danger">{errors.customer}</div> : null}
                          </div>
                        </div>

                        <div className="row">
                          <label className="block font-bold mb-2">Products</label>
                          {values.products.map( ( row, idx ) => {
                            const selectedProduct = products.find( p => String( p.id ) === String( row.productId ) );
                            const maxQty = selectedProduct ? Number( selectedProduct.availableQuantity ) : undefined;
                            return (
                              <div className="flex flex-wrap gap-2 items-end mb-2" key={idx}>
                                <div className="form-group w-3/12">
                                  <label>Product</label>
                                  <select
                                    className="form-control"
                                    value={row.productId}
                                    onChange={e => handleProductChange( idx, e )}
                                  >
                                    <option value={0}>--select product--</option>
                                    {products
                                      .filter( p =>
                                        row.productId === p.id ||
                                        !values.products.some( ( r, i ) => r.productId === p.id && i !== idx )
                                      )
                                      .map( p => (
                                        <option key={p.id} value={p.id}>{`${p.productName} (${p.packSize})`}</option>
                                      ) )}
                                  </select>
                                </div>
                                <div className="form-group w-3/12">
                                  <label>Quantity{maxQty !== undefined && <small className="text-muted text-xs ms-1">(Max: {maxQty})</small>}</label>
                                  <input
                                    type="number"
                                    className="form-control"
                                    min={1}
                                    max={maxQty}
                                    value={row.quantity === 0 ? '' : row.quantity}
                                    onChange={e => handleQuantityChange( idx, e )}
                                  />
                                  {errors.products && errors.products[ idx ] && errors.products[ idx ].quantity ? <div className="text-danger">{errors.products[ idx ].quantity}</div> : null}
                                </div>
                                <div className="form-group w-2/12">
                                  <label>Price</label>
                                  <input
                                    type="number"
                                    className="form-control"
                                    min={1}
                                    value={row.price === 0 ? '' : row.price}
                                    onChange={e => handlePriceChange( idx, e )}
                                  />
                                </div>
                                <div className="form-group w-2/12">
                                  <label>Amount</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={UTILS.thousandSeparator( row.amount )}
                                    disabled
                                  />
                                </div>
                                <div className="form-group w-1/12">
                                  {values.products.length > 1 && (
                                    <button type="button" className="btn btn-danger" onClick={() => removeProductRow( idx )}>-</button>
                                  )}
                                </div>
                              </div>
                            );
                          } )}
                          <div className="form-group">
                            <button type="button" className="btn bg-secondary-500 text-white" onClick={addProductRow}>+ Add Product</button>
                          </div>
                          {errors.products && typeof errors.products === 'string' ? <div className="text-danger">{errors.products}</div> : null}
                        </div>
                        <div className="row">
                          <div className="form-group my-2 w-10/12 md:w-6/12 ">
                            <label htmlFor="invoiceNumber">Invoice Number </label>
                            <Field className="form-control" id="invoiceNumber" name="invoiceNumber" />
                            {errors.invoiceNumber && touched.invoiceNumber ? <div className="text-danger">{errors.invoiceNumber}</div> : null}
                          </div>
                          <div className="form-group my-2 my-2 my-2 col-md-6 col-lg-6 col-sm-10">
                            <label htmlFor="file">Supporting Document</label>
                            <input type="file" className="form-control" id="file" name="file" onChange={( e ) => {
                              setFieldValue( "file", e.currentTarget.files[ 0 ] );
                              handleFileChange( e );
                            }} />
                          </div>
                        </div>
                        <div className="form-group my-2 row">
                          <div className="my-2 col-md-6 col-lg-6 col-sm-10">
                            {isLoading ? <Loading /> : (
                              <button type="submit" className="form-control bg-success" id="btnSubmit" name="btnSubmit" disabled={isSubmitting}>SUBMIT</button>
                            )}
                          </div>
                          <div className="my-2 col-md-6 col-lg-6 col-sm-10">
                            <input onClick={() => { navigate( -1, { replace: true } ) }}
                              type="button"
                              className="form-control"
                              value="Cancel"
                            />
                          </div>
                        </div>
                      </Form>
                    );
                  }}
                </Formik>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
  return <Login target='/sales' />

}
export default TransactionForm;
